import React from "react";
import "./style.css";

export default function DesktopOnlyGraphic() {
  return (
    <div className="pi-desktop-only-graphic" aria-hidden="true">
      <div className="pi-desktop-only-graphic__glow" />
      <svg
        className="pi-desktop-only-graphic__svg"
        viewBox="0 0 280 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label=""
      >
        <defs>
          <linearGradient id="pi-desktop-phone" x1="176" y1="24" x2="248" y2="136" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1e40af" />
            <stop offset="1" stopColor="#2563eb" />
          </linearGradient>
          <linearGradient id="pi-desktop-screen" x1="188" y1="40" x2="236" y2="112" gradientUnits="userSpaceOnUse">
            <stop stopColor="#dbeafe" />
            <stop offset="1" stopColor="#eff6ff" />
          </linearGradient>
        </defs>

        <g className="pi-desktop-only-graphic__monitor" opacity="0.55">
          <rect x="24" y="28" width="128" height="84" rx="10" stroke="#94a3b8" strokeWidth="2.25" fill="rgba(148, 163, 184, 0.08)" />
          <rect x="36" y="40" width="104" height="60" rx="4" fill="rgba(148, 163, 184, 0.12)" stroke="#cbd5e1" strokeWidth="1.5" />
          <path d="M68 124h40" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" />
          <path d="M88 124v8" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" />
          <circle cx="88" cy="70" r="14" stroke="#cbd5e1" strokeWidth="1.75" strokeDasharray="4 4" />
          <path d="M82 70h12M88 64v12" stroke="#cbd5e1" strokeWidth="1.75" strokeLinecap="round" />
        </g>

        <path
          className="pi-desktop-only-graphic__arrow"
          d="M148 80h28"
          stroke="#2563eb"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="5 6"
        />
        <path
          className="pi-desktop-only-graphic__arrow-head"
          d="M168 74l8 6-8 6"
          stroke="#2563eb"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g className="pi-desktop-only-graphic__phone">
          <rect x="176" y="24" width="72" height="112" rx="14" fill="url(#pi-desktop-phone)" />
          <rect x="184" y="36" width="56" height="88" rx="6" fill="url(#pi-desktop-screen)" />
          <circle cx="212" cy="132" r="4" fill="#dbeafe" />
          <rect x="200" y="30" width="24" height="4" rx="2" fill="rgba(255,255,255,0.35)" />
          <circle cx="212" cy="72" r="16" stroke="#2563eb" strokeWidth="2" fill="rgba(37, 99, 235, 0.12)" />
          <circle cx="212" cy="72" r="8" stroke="#3b82f6" strokeWidth="1.75" fill="rgba(59, 130, 246, 0.2)" />
          <circle cx="212" cy="72" r="3" fill="#2563eb" className="pi-desktop-only-graphic__camera-dot" />
        </g>

        <g className="pi-desktop-only-graphic__badge">
          <circle cx="236" cy="36" r="16" fill="#ffffff" />
          <circle cx="236" cy="36" r="16" stroke="rgba(37, 99, 235, 0.25)" strokeWidth="1.5" />
          <path d="M228 36l6 6 12-12" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </div>
  );
}
